const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/roles.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// Admin User Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/roles")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Users",
      description: "Page title"
    })
  }
});